import { render, staticRenderFns } from "./NotebooksView.vue?vue&type=template&id=f20738ba&scoped=true&"
import script from "./NotebooksView.vue?vue&type=script&lang=js&"
export * from "./NotebooksView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20738ba",
  null
  
)

export default component.exports